import PropTypes from "prop-types";
import s from "./FeaturedSection.module.css";
import ProductCard from "./ProductCard.jsx";

function SparkleIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 2l2.09 6.26L20.18 10l-6.09 1.74L12 18l-2.09-6.26L3.82 10l6.09-1.74L12 2z" />
    </svg>
  );
}

SparkleIcon.propTypes = {
  className: PropTypes.string,
};

export default function FeaturedSection({ group, onProductClick }) {
  const total = group.products.length;

  return (
    <div className={s.featured}>
      <div className={s.group}>
        <div className={s.header}>
          <SparkleIcon className={s.sparkle} />
          <span className={s.title}>Featured</span>
          <span className={s.count}>
            {total} product{total !== 1 ? "s" : ""}
          </span>
        </div>
        <div className={s.grid}>
          {group.products.map((product) => (
            <ProductCard
              key={product.product_id}
              product={product}
              onClick={onProductClick}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

FeaturedSection.propTypes = {
  group: PropTypes.shape({
    products: PropTypes.array.isRequired,
  }).isRequired,
  onProductClick: PropTypes.func.isRequired,
};
